import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../../app/appTypes";
import { getWithAuth, postWithAuth, putWithAuth } from "../../../http";

export interface CompanySetting {
    id: string;
    companyId: number;
    type: string;
    code: string;
    value: string;
    isActive: boolean;
    isFixed: boolean;
    isDefault: boolean;
    createDate: Date;
    createdBy: string;
    modifiedBy: string;
    modifyDate: Date;
}

export interface CompanySettingPayload {
    id?: string;
    type: string;
    code: string;
    value: string;
    isActive: boolean;
    isFixed: boolean;
}

export const loadCompanySettings = createAsyncThunk<CompanySetting[], void, AppThunkAPIType>("company-settings/load", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys/company-settings` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as CompanySetting[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const loadTypes = createAsyncThunk<string[], void, AppThunkAPIType>("company-settings/load-types", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys/company-settings/types` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as string[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const loadCodes = createAsyncThunk<string[], void, AppThunkAPIType>("company-settings/load-codes", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys/company-settings/codes` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as string[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const createCompanySettings = createAsyncThunk<CompanySetting, CompanySettingPayload, AppThunkAPIType>("company-settings/create", async (setting, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(postWithAuth({ url: `api/sys/company-settings`, payload: setting }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as CompanySetting
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const updateCompanySetting = createAsyncThunk<CompanySetting, CompanySettingPayload, AppThunkAPIType>("company-settings/update", async (setting, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(putWithAuth({ url: `api/sys/company-settings/${setting.id}`, payload: setting }))
    const { payload } = result
    if (putWithAuth.fulfilled.match(result)) {
        return payload as CompanySetting
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const restoreDefaultCompanySetting = createAsyncThunk<CompanySetting, string, AppThunkAPIType>("company-settings/restore-default", async (id, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(putWithAuth({ url: `api/sys/company-settings/restore/${id}`, payload: {} }))
    const { payload } = result
    if (putWithAuth.fulfilled.match(result)) {
        return payload as CompanySetting
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})